import { Icon } from "@iconify/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchGeneralPage } from "../Redux/slice/homeSlice";
import { Link } from "react-router-dom";
import { API_URL } from "../Api";


const FooterRap = styled.div`
  .footer-1-upper p {
    color: #000000cc;
    max-width: 500px;
    font-size: 18px;
    font-weight: 400;
  }
  .footer-1-upper h2 {
    color: #1a365d;
    font-size: 48px;
    font-weight: 400;
    line-height: 57px;
    max-width: 580px;
  }
  .footer-1-upper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .footer-1-down-button {
    border: none;
    background: #1a365d;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 15px;
    font-weight: 500;
    width: 175px;
    height: 48px;
    border-radius: 100px;
  }
  .blue-circle {
    background: #1a365d;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .blue-circle svg {
    color: #0ea5e9;
  }
  .footer-1-down {
    display: flex;
    width: fit-content;
    cursor: pointer;
  }
  .footer-1-down:hover .footer-1-down-button {
    color: #1a365d;
    background: #0ea5e9;
  }
  .footer-1-down:hover .blue-circle {
    color: #1a365d;
    background: #0ea5e9;
  }
  .footer-1-down:hover .blue-circle svg {
    color: #1a365d;
  }
  .footer-1-upper img {
    width: 150px;
    height: 37px;
  }
  .footer-1 {
    display: flex;
    flex-direction: column;
    gap: 70px;
  }
  .footer-2 h4 {
    color: #000000cc;
    font-size: 15px;
    font-weight: 500;
  }
  .footer-2-sub p {
    color: #1a365d;
    font-size: 16px;
    font-weight: 400;
    max-width: 210px;
  }

  .footer-2-sub h5 {
    color: #000000cc;
    font-size: 16px;
    font-weight: 400;
  }
  .footer-2-sub,
  .footer-2 {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .footer-2 {
    gap: 40px;
  }
  .footer {
    background: #f6f5f2;
    padding-top: 100px;
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    gap: 30px;
    align-items: flex-end;
  }
  .footer-links {
    text-decoration: none;
    color: #1a365d;
    font-weight: 500;
    font-size: 16px;
  }
  .footer-fixed-upper {
    display: flex;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 40px;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 20px;
  }
  .fixed-right {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .fixed-left p {
    font-size: 14px;
    font-weight: 400;
    color: #000000cc;
  }
  .footer-fixed-down {
    padding-top: 40px;
    padding-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    border-top: 1px solid #0000001a;

    flex-wrap: wrap;
  }
  @media (max-width: 700px) {
    .footer {
      flex-wrap: wrap;
    }
  }
`;

const Footer = () => {
  const dispatch = useDispatch();

  const currentYear = new Date().getFullYear();
  const iconMap = {
    Facebook: "ic:sharp-facebook",
    Twitter: "prime:twitter",
    Instagram: "mdi:instagram",
    LinkedIn: "mingcute:linkedin-fill",
  };
  const { contactObject, generalObject } = useSelector(
    (state) => state.content,
  );
  // console.log(generalObject);
  const socialLinks = generalObject?.data?.socialLinks || [];
  const websetting = generalObject?.data?.websetting;
  const footerData = generalObject?.data?.footer;

  useEffect(() => {
    dispatch(fetchGeneralPage());
  }, [dispatch]);
  return (
    <FooterRap>
      <div className="all-footer-div">
        <div className="footer containers">
          <div className="footer-1">
            <div className="footer-1-upper">
              <img
                src={`${API_URL}/${websetting?.logo_url}`}
                alt=""
              />
              <h2>{footerData?.main_title}</h2>
              <p>{footerData?.content}</p>
            </div>
            <div className="footer-1-down">
              <a
                className="footer-1-down-button"
                href={footerData?.first_btn_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {footerData?.first_btn_title}
              </a>
              <div className="blue-circle">
                <Icon width="14px" height="14px" icon="mdi:arrow-top-right" />
              </div>
            </div>
          </div>
          <div className="footer-2">
            <h4>CONTACT US</h4>
            <div className="footer-2-sub">
              <h5>Telephone</h5>
              <p>{websetting?.biz_phone}</p>
              <p>{websetting?.biz_phone_two}</p>
            </div>
            <div className="footer-2-sub">
              <h5>Email Address</h5>
              <p>{websetting?.biz_email}</p>
            </div>
          </div>
          <div className="footer-2">
            <div className="footer-2-sub">
              <h5>Mon - Fri</h5>
              <p>8:00am-9:00pm</p>
            </div>
            <div className="footer-2-sub">
              <p>{websetting?.first_address}</p>
            </div>
          </div>
        </div>
        <div className="footer-fixed containers">
          <div className="footer-fixed-upper">
            <Link className="footer-links" to="/about">
              Who we Are
            </Link>

            <Link className="footer-links" to="/services">
              Services
            </Link>
            <Link className="footer-links" to="/insights">
              Insights
            </Link>
            <Link className="footer-links" to="/testimonials">
              Testimonials
            </Link>

            <Link className="footer-links" to="/contact">
              Contact
            </Link>
          </div>
          <div className="footer-fixed-down">
            <div className="fixed-left">
              <p>
                © {currentYear} Holybrooks Transportation. All Right Reserved
              </p>
            </div>
            <div className="fixed-right">
              {socialLinks.map((item) => (
                <div className="footer-icon">
                  <a
                    key={item.id}
                    href={item.social_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-icon"
                  >
                    <Icon
                      icon={iconMap[item.social_name] || "ic:baseline-share"}
                      width="40px"
                      height="40px"
                      style={{ color: "#1a365d" }}
                    />
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </FooterRap>
  );
};
export default Footer;
